module.exports = "/_next/static/resources/photo-4-5cda328526e7a62f27c1259c159fab09.jpg";